export default __webpack_public_path__ + "static/media/arrow-left.dda58364.svg";